import {get} from 'lodash'
export default {
    state:{
        etude:{
            etudeID:null,
            etudeNom:null,
            etude_no:null,
            created_at:null,
            etudeAvancement:null,
            ipid:true,
            tg:true,
            cg:true,
            conseilpath:null,
            selectedRisque:0,
            Tiers:{},
            itemsRisque:{ItemsRisque:[]},
            Enfant:[{}],
            Beneficiers:[],
            beneficieresData: [],
            checkedBeneficieresData : [],
            autreBeneficiers: null,
            Parent:[{}],
            Ami:[{}],
            Conjoint:{},
            Entreprise:{},
            checkedRisque:[],
            changedRisque:false,
            step:'choix',
            activeStep:[{indexStep:0,active:'choix'}]
        },
        beneficieresData: [],
        autreBeneficiers: null,
        checkedBeneficieresData :[]
        
    },
    mutations:{
        setProspect(state,payload)
        {
            state.etude.Tiers=payload.Tiers
        },
        setProspectEmailAndTel(state,payload)
        {
            state.etude.Tiers.moyen_contact.tel = payload.Tiers.moyen_contact.tel
            state.etude.Tiers.moyen_contact.email = payload.Tiers.moyen_contact.email
        },
        setEtude(state,payload)
        {
            state.etude.etudeID=payload.etudeID
            state.etude.etudeNom=payload.etudeNom
            state.etude.etude_no=payload.etude_no
        },
        setItemsRisque(state,payload)
        {
            payload.ItemsRisque.map((it)=>{
                state.etude.itemsRisque.ItemsRisque.push(it)
            })
            state.etude.changedRisque=!state.etude.changedRisque
        },
        setItemsRisqueGlobal(state,payload)
        {
            state.etude.itemsRisque=payload
        },
        setChangedRisque(state,payload)
        {
            state.etude.changedRisque=!state.etude.changedRisque
        },
        setStepTarif(state,payload)
        {

            state.etude.activeStep.find(as => as.active == payload.step) ? console.log("already exists")
                                                                         : state.etude.activeStep.push(payload.step)

            state.etude.step=payload.step.active

        },
        setObjetEnfant(state,payload)
        {
            state.etude.Enfant=payload
        },
        setObjetBeneficiers(state,payload)
        {
            state.etude.Beneficiers=payload
        },
        setBeneficieresData(state, beneficieresData) {
            state.beneficieresData = beneficieresData;
            console.log(state.beneficieresData,'beneficiereDatastate')
        },
        setAutreBeneficiers(state, autreBeneficiers) {
            state.autreBeneficiers = autreBeneficiers;
        },
        setCheckedBeneficieresData(state, checkedBeneficieresData){
            state.checkedBeneficieresData  = checkedBeneficieresData;
        },
        setObjetParent(state,payload)
        {
            state.etude.Parent=payload
        },
        setObjetAmi(state,payload)
        {
            state.etude.Ami=payload
        },
        setcheckedRisque(state,payload)
        {
            state.etude.checkedRisque=payload
        },
        setEtudeAvancement(state,payload)
        {
            state.etude.etudeAvancement=payload
        },
        setEtudeConseil(state,payload)
        {
            state.etude.conseilpath=payload.conseilpath
        },
        setSelectedRisque(state,payload)
        {
            state.etude.selectedRisque=payload.selectedRisque
        },
        setObjetConjoint(state,payload)
        {
            state.etude.Conjoint=payload.Conjoint
        },
        setObjetEntreprise(state,payload)
        {
            state.etude.Entreprise=payload.Entreprise
        },
        setActiveStep(state,payload)
        {
            state.etude.activeStep=payload.activeStep
        },
        clearData(state){
            state.etude={
                etudeID:null,
                etudeNom:null,
                etudeAvancement:null,
                ipid:true,
                tg:true,
                cg:true,
                conseilpath:null,
                selectedRisque:0,
                Tiers:{},
                itemsRisque:{ItemsRisque:[]},
                Enfant:[{}],
                beneficieresData: [],
                autreBeneficiers: null,
                Parent:[{}],
                Ami:[{}],
                Conjoint:{},
                Entreprise:{},
                checkedRisque:[],
                changedRisque:false,
                step:'choix',
                activeStep:[{indexStep:0,active:'choix'}]
            },
            state.beneficieresData= [],
            state.autreBeneficiers= []
            
        },
        setVehiculeImmatriculation(state,payload) {
            state.etude.itemsRisque.ItemsRisque[0].objets.objet_moto[1].vehicule.immatriculation = payload.immatriculation
        },
        setObjetEmprunteur(state,payload) {
            state.etude.itemsRisque.ItemsRisque[0].objets.objet_emprunteurs[0] = payload.objet_emprunteurs
        }
        
    },
    actions:{
        clearData ({ commit }) {
            commit('clearData')
        },
    },
    getters:{
        Tiers(state) {
            return state.etude.Tiers;
        },
        Enfant(state) {
            return state.etude.Enfant;
        },
        BeneficieresData(state) {
            return state.beneficieresData;
          },
        checkedBeneficieresData(state){
            return state.checkedBeneficieresData
        },
        AutreBeneficiers(state) {
            return state.autreBeneficiers;
        },
        Parent(state) {
            return state.etude.Parent;
        },
        Ami(state) {
            return state.etude.Ami;
        },
        Conjoint(state) {
            return state.etude.Conjoint;
        },
        Entreprise(state) {
            return state.etude.Entreprise;
        },
        getItemsRisque(state) {
            return state.etude.itemsRisque;
        },
        getEtude(state) {
            return state.etude;
        },
        getObjetEnfant(state) {
            return state.etude.Enfant;
        },
        getObjetBeneficiers(state) {
            return state.etude.Beneficiers;
        },
        getObjetParent(state) {
            return state.etude.Parent;
        },
        getObjetAmi(state) {
            return state.etude.Ami;
        },
        getObjetConjoint(state) {
            return state.etude.Conjoint;
        },
        getObjetEntreprise(state) {
            return state.etude.Entreprise;
        },
        getCheckedRisque(state) {
            return state.etude.checkedRisque;
        },
        getSelectedRisque(state) {
            return state.etude.selectedRisque;
        },
        getChangedRisque(state) {
            return state.etude.changedRisque;
        },
        getStepTarif(state) {
            return state.etude.step;
        },
    }
};
